import { PRODUCT_PACKAGING_TYPE_TO_LABEL } from "@/constants/product"
import type { ProductPackagingType } from "@/graphql/codegen/graphql"

export const getProductPackagingTypeLabel = (packagingType: ProductPackagingType | null | undefined): string => {
  if (!packagingType) return ""

  return PRODUCT_PACKAGING_TYPE_TO_LABEL[packagingType] ?? packagingType
}
